import { typography } from '@joor/design-system'
import '@joor/design-system/dist/designTokens/variables.css'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 20px 20px;
  font-family: var(--font-family-alpha);
  color: var(--color-primary-900);
  max-height: 100vh;
  overflow-y: scroll;
  overflow-x: hidden;

  textarea {
    border-radius: 5px;
    border: 1px solid var(--color-primary-400);
    font-family: var(--font-family-alpha);
    font-size: var(--size-font-small);
  }
`
export const Title = styled.p`
  font-size: 36px !important;
  ${typography.alpha.primaryActive.headline1};
  margin: 0 !important;
  line-height: 60px;
`
export const Info = styled.p`
  ${typography.alpha.primaryActive.body1};
  margin: 8px 0 0 !important;
`
export const Subtitle = styled.span`
  font-size: var(--size-font-small);
  font-weight: var(--font-weight-semibold);
  margin-top: 24px;
`
export const Block = styled.div`
  margin-top: 1em;
`
export const Label = styled.span`
  font-size: var(--size-font-small);
  font-weight: var(--font-weight-medium);
`
/**
 * The design system paints a TextField red only when it is handed an
 * errorMessage, and then prints that message under the input. An inverted range
 * is a fault of the pair, not of one end, so both ends are flagged with a blank
 * message, those message rows are hidden here, and the text is rendered once
 * below the row as RangeError.
 */
export const PricesContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;

  /* The error message the design system renders under each input. */
  & > label > span {
    display: none;
  }

  & > div {
    flex: 1 1 0;
    min-width: 0;
  }

  input {
    width: 100%;
    box-sizing: border-box;
  }

  .spacer {
    flex: 0 0 auto;
    margin: 30px 0 0;
  }
`

// Mirrors the design system's own error caption, which this row replaces.
export const RangeError = styled.span`
  display: block;
  color: var(--color-error-500);
  font-family: var(--font-family-alpha);
  font-size: var(--size-font-extrasmall);
  font-weight: var(--font-weight-medium);
  letter-spacing: var(--letter-spacing-tight);
  line-height: var(--line-height-12);
  margin-top: 4px;
`
